import { useTranslation } from 'react-i18next'

const AdultEnd = (props) => {
  const { t } = useTranslation()
  
  return (
    <svg 
      xmlns="http://www.w3.org/2000/svg" 
      viewBox="0 0 1920 1080"
      role="image"
      aria-labelledby="adult-end-title"
      {...props}
    >
      <title id="adult-end-title">{t('antagonists:adult:components:end')}</title>
      <defs>
        <clipPath id="b">
          <path
            d="m1657.51 332.61 26.67 42.52s101.31 40.61 93.82 73.03c-7.48 32.42-60.44 174.71-62.95 224.58-2.49 49.9 29.76 116.5 29.76 116.5s-42.68 17.39-79.59 53.31c-15.11 14.71-30.32 27.42-48.07 35.39-61.12 27.43-124.76-11.53-149.71-22.76-24.95-11.22-27.37-9.82-27.37-9.82s36.17-81.08 37.41-133.46c1.24-52.38-18.72-243.23-23.7-264.43-4.99-21.2-16.21-41.16 9.98-56.13 26.19-14.97 76.67-25.74 76.67-25.74l29.71-29.01 87.31-4.01h.03Z"
            style={{
              fill: 'none',
            }}
          />
        </clipPath>
        <clipPath id="c">
          <path
            d="M1737.9 835.97s-10.48-15.28-22.96-23.83c-12.48-8.55-22.96-16.9-22.96-16.9s68.89-91.83 65.85-108.3c-4.51-24.46-9.96-51.55-9.96-51.55s75.26-25.14 81.01-1.73c12.14 49.38 3.73 72.77-19.91 112.19-23.65 39.42-71.06 90.11-71.06 90.11v.02Z"
            style={{
              fill: 'none',
            }}
          />
        </clipPath>
        <clipPath id="d">
          <path
            d="M1453.56 400.31c-25.62 24.31-37.45 154.38-44.66 202.33-7.23 47.96-19.72 157.66-15.76 210.88 3.94 53.21 13.85 101.45 13.85 101.45s5.84-6.8 25.55-8.77 38.5-3.82 38.5-3.82-12.36-49.55-11.05-61.38-.5-69.54 1.48-105.66c1.97-36.14 25.62-142.56 25.62-142.56l-5.9-181.97-27.59-10.51-.03.02Z"
            style={{
              fill: 'none',
            }}
          />
        </clipPath>
        <style>
          {
            '.e{fill:none}.f{fill:#f08b27}.g{fill:#d88b46}.h{fill:#dfbe84}.i{fill:#c4c7c9}.j{fill:#c6a4c9}.k{fill:#283a50}.l{fill:#58b6e3}.m{fill:#2e425b}.n{fill:#3b9bd2}.o{fill:#5b3346}.p{fill:#75c6cf}.q{clip-path:url(#c)}.r{clip-path:url(#b)}.s{clip-path:url(#d)}'
          }
        </style>
      </defs>
      <path
        d="M1597.15 306.02s-31.13-.86-37.9 4.04c-6.77 4.89-9.2 20.13-10.05 28.28-.85 8.13-.78 19.18-.78 19.18l67.49 14.97-18.77-66.45v-.02Z"
        style={{
          fill: '#2e425b',
        }}
      />
      <path
        d="M1721.84 797.4c2.26.76 5.28 134.32 4.52 181.87-.76 47.55 3.78 163.76 2.26 194.7-1.5 30.94-4.52 184.13-10.57 226.38-6.04 42.26-11.33 83.01-11.33 83.01s-27.92-1.5-39.24-1.5-31.09-6.3-31.09-6.3 1.66-138.59 4.68-197.46c3.02-58.86 3.78-89.8.76-116.97-3.02-27.16-42.26-205.26-42.26-205.26l-21.13-101.88 143.39-56.59.02.02Z"
        style={{
          fill: '#c6a4c9',
        }}
      />
      <path
        d="M1611.65 895.5s-33.2 110.17-52.07 165.26c-18.87 55.09-22.63 80.75-21.13 114.71s9.05 101.12 7.54 156.21c-1.5 55.09 0 115.38 0 115.38s-15.07 9.13-39.99 9.13-34.72-10.57-34.72-10.57-15.85-221.86-19.61-246.77c-3.78-24.9 3.78-174.33 3.02-211.29-.76-36.98 22.63-161.5 22.63-161.5l65.66-46.79 68.66 116.21Z"
        style={{
          fill: '#c6a4c9',
        }}
      />
      <path
        d="m1657.51 332.61 26.67 42.52s101.31 40.61 93.82 73.03c-7.48 32.42-60.44 174.71-62.95 224.58-2.49 49.9 29.76 116.5 29.76 116.5s-42.68 17.39-79.59 53.31c-15.11 14.71-30.32 27.42-48.07 35.39-61.12 27.43-124.76-11.53-149.71-22.76-24.95-11.22-27.37-9.82-27.37-9.82s36.17-81.08 37.41-133.46c1.24-52.38-18.72-243.23-23.7-264.43-4.99-21.2-16.21-41.16 9.98-56.13 26.19-14.97 76.67-25.74 76.67-25.74l29.71-29.01 87.31-4.01h.03Z"
        style={{
          fill: '#3b9bd2',
        }}
      />
      <g
        style={{
          clipPath: 'url(#b)',
        }}
      >
        <path
          d="m1686.19 364.1-53.07 56.15-33.98-25.66-31.08 23.12-31.03-62.78s21.53-50.26 22.74-50.66c1.19-.4 109.68 1.59 109.68 1.59l16.75 58.24h-.02Z"
          style={{
            fill: '#58b6e3',
          }}
        />
      </g>
      <path
        d="M1747.86 414.76s19.04-1.31 34.17 28.25c15.11 29.56 52.55 194.46 49.27 226.64-3.28 32.18-13.14 32.18-34.17 32.86-21.03.66-36.14-11.83-47.96-49.27-11.83-37.45-44.66-135.98-44.66-135.98l43.35-102.49Z"
        style={{
          fill: '#3b9bd2',
        }}
      />
      <path
        d="M1468.35 900.65s9.17 11.07 10.43 18.97c1.26 7.91-.31 26.24 0 33.84s.31 21.82.31 21.82-10.76-.31-13.59-7.91c-2.85-7.6-1.26-31.94-3.8-31.94s-.64 26.55.95 34.46c1.59 7.91 10.43 13.28 13.28 18.34s2.54 10.12 2.54 10.12l-24.98-1.59s-17.08-10.12-24.65-13.92c-7.6-3.8-12.97-9.48-16.13-14.87-2.14-3.64-4.11-29.09-4.11-29.09l1.26-31.3s18.34-6.32 30.35-6.32 28.14-.64 28.14-.64v.02Z"
        style={{
          fill: '#dfbe84',
        }}
      />
      <path
        d="M1737.9 835.97s-10.48-15.28-22.96-23.83c-12.48-8.55-22.96-16.9-22.96-16.9s68.89-91.83 65.85-108.3c-4.51-24.46-9.96-51.55-9.96-51.55s75.26-25.14 81.01-1.73c12.14 49.38 3.73 72.77-19.91 112.19-23.65 39.42-71.06 90.11-71.06 90.11v.02Z"
        style={{
          fill: '#3b9bd2',
        }}
      />
      <g
        style={{
          clipPath: 'url(#c)',
        }}
      >
        <path
          d="M1733.53 790.75c13.23 12.86 36.2 44.79 36.2 44.79l-78.8 53.4-54.99-88.17 36.03-41.71s41.38 12.07 61.55 31.7Z"
          style={{
            fill: '#58b6e3',
          }}
        />
      </g>
      <path
        d="M1453.56 400.31c-25.62 24.31-37.45 154.38-44.66 202.33-7.23 47.96-19.72 157.66-15.76 210.88 3.94 53.21 13.85 101.45 13.85 101.45s5.84-6.8 25.55-8.77 38.5-3.82 38.5-3.82-12.36-49.55-11.05-61.38-.5-69.54 1.48-105.66c1.97-36.14 25.62-142.56 25.62-142.56l-5.9-181.97-27.59-10.51-.03.02Z"
        style={{
          fill: '#3b9bd2',
        }}
      />
      <g
        style={{
          clipPath: 'url(#d)',
        }}
      >
        <path
          d="M1428.07 866.82c34.13-8.53 59.74-2.85 59.74-2.85l13.28 61.62-126.1 24.65-3.8-52.14s7.58-18.96 56.89-31.28Z"
          style={{
            fill: '#58b6e3',
          }}
        />
        <path
          style={{
            fill: 'none',
          }}
          d="m1838.83 1015.99 78.69 90.08"
        />
      </g>
      <path
        d="M1660.1 289.57s-1.43 13.67-.86 32.84c.57 19.16 2.62 20.7-4.26 27.81-6.89 7.13-55.84 41.45-55.84 41.45s-24.52-27.05-32.51-35.48c-7.99-8.43-7.13-61.91-7.13-61.91l100.6-4.73v.02Z"
        style={{
          fill: '#dfbe84',
        }}
      />
      <path
        d="M1638.57 148.7c-34.55-4.39-64.62 15.49-72.77 36.36-14.16 36.22-9 70.39-9 70.39s130.21 14.43 128.45 14.11c-1.78-.33 8.49-48.65 7.8-68.92-.69-20.27-18.68-47.41-54.47-51.95l-.02.02Z"
        style={{
          fill: '#f08b27',
        }}
      />
      <path
        d="M1627.23 205.07c-31.65 10.98-60.79-1.71-68.01 40.12-3.61 20.91-3.44 43.25.6 62.64 4.02 19.39 11.91 35.83 23.69 44.94 23.57 18.23 34.18 8.94 51.07 1.09 16.89-7.86 26.26-26 33.53-44.03 7.27-18.01 7.91-53.99 10.41-73.15 2.5-19.16 2.19-37.26-10.12-41.38-12.31-4.11-27.05 4.87-41.16 9.75l-.02.02Z"
        style={{
          fill: '#dfbe84',
        }}
      />
      <path
        d="M1670.18 274.63s10.12-23.5 23.89-15.99c13.78 7.53-4.23 35.58-8.1 43.75-3.87 8.18-6.85 7.35-11.34 4.7-4.47-2.66-11.38-9.17-11.38-9.17l6.94-23.31-.02.02ZM1565.35 246.06s-4.59-10.53-10.65-7.46c-6.06 3.06-2.57 18.09-5.09 28.88s-.22 19.58 5.54 20.91 9.96-1.55 9.96-1.55l.22-40.76.02-.02Z"
        style={{
          fill: '#dfbe84',
        }}
      />
      <path
        d="M1625.22 250.25s25.78-2.12 32.23 2.85c6.46 4.97 7.51 10.17 7.51 10.17l-3.06 2.14s-4.13-5.84-12.17-6.22c-8.05-.38-25.09-1.05-25.09-1.05l.57-7.89ZM1600.76 247.91s-15.64-7.87-23.43-5.84c-7.79 2.04-13.62 7.84-13.62 7.84l1.43 4.3s5.7-7.56 15.14-4.89c9.44 2.66 19.08 4.9 19.08 4.9l1.4-6.32Z"
        style={{
          fill: '#5b3346',
        }}
      />
      <path
        style={{
          fill: '#5b3346',
        }}
        d="m1629.18 263.84 21.51 4.92 1.26-5.33-21.53-2.52-1.24 2.93zM1575.59 261.22l21.32-2.45-.36-5.89-21.6 4.59.64 3.75z"
      />
      <path
        d="M1588.72 257.42c-3.49.92-5.32 3.92-4.28 7.3s3.63 4.18 6.8 3.56c3.75-.74 5.28-3.54 4.58-7.11-.5-2.54-3.49-4.7-7.08-3.75h-.02ZM1644.01 265.48c-3.37-1.28-6.61.09-7.73 3.44-1.14 3.35.5 5.51 3.45 6.85 3.49 1.59 6.35.21 7.86-3.11 1.07-2.35-.1-5.84-3.57-7.16v-.02Z"
        style={{
          fill: '#5b3346',
        }}
      />
      <path
        style={{
          fill: '#c6a4c9',
        }}
        d="m1541.73 919.17 43.04-106.87 35.83 101.64-78.87 5.23z"
      />
      <path
        d="M1600.34 412.82c-2.11.14-3.49 1.64-3.28 3.69s1.61 2.8 3.49 2.8c2.24 0 3.42-1.43 3.42-3.56 0-1.5-1.47-3.07-3.64-2.94h.02ZM1597.31 483.45c-2.11.14-3.49 1.64-3.28 3.69s1.61 2.8 3.49 2.8c2.24 0 3.42-1.43 3.42-3.56 0-1.5-1.47-3.07-3.64-2.94h.02ZM1592.28 547.09c-2.11.14-3.49 1.64-3.28 3.69s1.61 2.8 3.49 2.8c2.24 0 3.42-1.43 3.42-3.56 0-1.5-1.47-3.07-3.64-2.94h.02ZM1594.16 609.99c-2.11.14-3.49 1.64-3.28 3.69-.07-.67-.85 2.81 3.49 2.8 2.24 0 3.42-1.43 3.42-3.56 0-1.5-1.47-3.07-3.64-2.94h.02ZM1585.39 677.12c-2.11.14-3.49 1.64-3.28 3.69s1.04 3.19 2.93 3.19c2.24 0 3.99-1.81 3.99-3.95 0-1.5-1.47-3.07-3.64-2.94ZM1587.33 756.95c-2.11.14-3.49 1.64-3.28 3.69s1.61 2.8 3.49 2.8c2.24 0 2.9-1.52 2.9-3.66 0-1.5-.93-2.99-3.11-2.85v.02Z"
        style={{
          fill: '#75c6cf',
        }}
      />
      <path
        d="M1584.1 322.46c-.43 3.28 3.82 6.91 7.11 9.7 2.57 2.18 4.63 2.76 8.55 3.25 4.3.54 9.1.71 12.9-1.52 4.14-2.42 8.44-5.87 9.29-8.53.85-2.64-8.24-7.48-11.83-8.37-1.86-.47-7.91 1.57-7.91 1.57s-2.56-2.45-6.92-2.69c-4.37-.24-10.76 3.3-11.19 6.58v.02Z"
        style={{
          fill: '#d88b46',
        }}
      />
      <path
        d="m1576.29 355.66 3.42 35.96 15.94 9.62s-9.29 143.51-20.11 182.53c-10.83 39.04-20.86 138.31-23.08 166.14-2.23 27.81 1.28 106.49 1.28 106.49l-22.53 1.69-.9 28.63s-27.12-2.07-63.93-5.82c-36.33-3.69-66.02-5.97-66.02-5.97s21.12-80.2 31.35-138.17c10.24-57.98 16.99-116.23 22.67-152.17 5.68-35.95-10.88-187.76.1-193.87 10.98-6.13 91.14-36.81 91.14-36.81s2.33-29.21 5.51-33.86 7.54-9.24 7.54-9.24-7.67 10.64-1.54 21.62 19.15 23.22 19.15 23.22l.02.02Z"
        style={{
          fill: '#2e425b',
        }}
      />
      <path
        style={{
          fill: '#283a50',
        }}
        d="m1446.27 458.66 87.14 30.75-18.7 41.21-75.54-27.03 7.1-44.93zM1477.69 739.74s-9.69 86.01-12.02 97.72c-2.33 11.71-9.62 15.33-25.03 15.5-15.42.17-35.93-1.62-35.93-1.62s-11.31-37.84-5.44-67.47c5.87-29.63 17.92-83.96 17.92-83.96l60.51 39.83h-.02Z"
      />
      <path
        style={{
          fill: '#283a50',
        }}
        d="m1407.06 738.99 82.05 8.9 9.03-51.78-83.55-7.62-7.53 50.5z"
      />
      <path
        d="M1470.75 724.6c-4.66-.17-7.32 3.75-7.54 6.54s.71 7.32 6.15 7.98c5.78.71 7.35-2.69 8.46-6.23 1.1-3.54-1.69-8.1-7.06-8.29ZM1506.77 507.04c-4.13-.16-6.47 3.31-6.68 5.78-.19 2.47.62 6.47 5.44 7.06 5.13.62 6.51-2.38 7.48-5.51.97-3.12-1.5-7.16-6.25-7.34h.02ZM1633.54 620.87c-4.58.21-6.87 4.23-6.87 6.98s1.26 7.1 6.63 7.32c5.71.24 6.98-3.21 7.79-6.75s-2.3-7.79-7.54-7.54ZM1670.94 715.82c-4.58.21-6.87 4.23-6.87 6.98s1.26 7.1 6.63 7.32c5.71.24 6.98-3.21 7.79-6.75.79-3.54-2.3-7.79-7.54-7.54ZM1453.78 487.32c-3.14-.78-5.75 2.24-6.47 4.61-.73 2.37-1.02 6.37 2.54 7.68 3.78 1.38 5.54-1.33 7.03-4.21 1.47-2.9.52-7.18-3.09-8.06v-.02Z"
        style={{
          fill: '#c4c7c9',
        }}
      />
      <path
        d="M1402 575.6c-24.55 5.52-25.97 98.76-27.24 129.23-3.57 85.39 24.84 201.98 24.84 201.98s20.11-9.34 37.19-14.14c16.37-4.61 34.27-5.63 34.27-5.63s-20.84-112.84-20.63-143.78c.19-30.96-8.06-176.73-48.39-167.64l-.03-.02Z"
        style={{
          fill: '#2e425b',
        }}
      />
      <path
        d="M1450.83 392.97c-37.97 26-70.25 197.22-73.31 228.97-3.06 31.75-1.5 68.04-1.19 81.66.31 13.62 34.41-2.45 50.76-3.64s31.44-11.03 38.03-35.01c6.6-24-2.04-110.79 7.53-158.37 9.56-47.57 22.89-107.82 21.62-116-1.28-8.18-27.24-8.72-43.47 2.4h.03ZM1657.91 348.77c-1.21 9.13-5.21 13.62-13.21 19.7-12.02 9.13-19.94 18.25-19.94 18.25l-13.86 32.72s-5.54 171.32 3.97 213.17c9.53 41.85 110.95 256.9 110.95 256.9l64.8-40.71s-40.38-103.73-54.83-127.93-5.99-83.49 7.48-137.9c13.47-54.42 39.8-151.98 26.97-166.8-12.83-14.8-42.64-22.91-61.33-33.22-18.68-10.31-30.3-18.16-30.3-18.16s-14.45-31.3-18.06-31.89c-1.43-.24-1.74 9.03-2.64 15.85l.02.02Z"
        style={{
          fill: '#2e425b',
        }}
      />
      <path
        d="m1656.3 517.43 14.49 43.94s49.33-17.25 62.95-18.75c13.64-1.5 31.61-6.39 30.78-6.2s-9.6-47.29-9.6-47.29-30.9 7.53-55.18 13.23c-24.26 5.7-43.46 15.07-43.46 15.07h.02Z"
        style={{
          fill: '#283a50',
        }}
      />
      <path
        d="M1765.78 411.23c-40.23-25.17-25.41 117.07-40.85 155.68-3.04 7.61 17.52 84.56 22.1 100.55 4.33 15.19-8.37 48-8.37 48s81.77 33.98 92.94-9.91c11.17-43.89-5.08-127.16-16-158.46-11.43-32.75-36.52-127.57-49.79-135.88l-.02.02Z"
        style={{
          fill: '#2e425b',
        }}
      />
      <path
        d="M1681.61 535.56c-4.13-.19-6.51 3.26-6.72 5.73-.22 2.47.57 6.47 5.39 7.11 5.11.67 6.53-2.33 7.53-5.46s-1.43-7.16-6.18-7.39h-.02ZM1634.74 620c-3.68-.17-5.8 2.9-5.99 5.11-.19 2.19.5 5.77 4.8 6.34 4.56.6 5.82-2.07 6.72-4.85s-1.28-6.39-5.52-6.58V620ZM1666.95 707.64c-3.68-.17-5.8 2.9-5.99 5.11-.19 2.19.5 5.77 4.8 6.34 4.56.6 5.82-2.07 6.72-4.85s-1.28-6.39-5.52-6.58v-.02Z"
        style={{
          fill: '#c4c7c9',
        }}
      />
      <path
        d="m1737.9 821.24-15.97 36.1s-8.53 4.75-24.98 1.26c-16.44-3.47-27.92-7.56-27.92-7.56s-7.13 16.78-11.55 25.33c-4.42 8.53-19.03 6.27-19.03 6.27s9.98-18.96 11.55-31.28c1.59-12.33 5.89-19.11 10.01-25.76 4.11-6.65 44.53-31.18 44.53-31.18s12.33 11.38 19.29 18.34c6.96 6.96 14.38 8.81 14.07 8.48v.02Z"
        style={{
          fill: '#dfbe84',
        }}
      />
      <path
        d="M1757.99 660.99c-9.75 16.92-15.45 43.21-33.84 68.2-18.37 24.98-38.92 67.92-38.92 67.92s60.44 42.06 60.13 42.83c0 0 42.07-49.34 57.03-76.73 14.93-27.38 20.03-32.68 28.59-52.8 8.56-20.11-1.69-56.66-23.79-71.89-32.51-22.43-36.9 1.12-49.21 22.46Z"
        style={{
          fill: '#2e425b',
        }}
      />
      <path
        style={{
          fill: '#283a50',
        }}
        d="m1620.3 420.59 25.59 25.59 20.17.78-.78-16.29-34.12-34.13-10.86 24.05z"
      />
      <path
        d="M1636.62 413.24c-3.02-.14-4.75 2.38-4.9 4.18s.41 4.73 3.94 5.2c3.75.48 4.77-1.69 5.49-3.97.73-2.28-1.05-5.23-4.52-5.39v-.02ZM1653.73 426.32c-3.02-.14-4.75 2.38-4.9 4.18s.41 4.73 3.94 5.2c3.75.48 4.77-1.69 5.49-3.97.73-2.28-1.05-5.23-4.52-5.39v-.02Z"
        style={{
          fill: '#c4c7c9',
        }}
      />
    </svg>
  )
}

export default AdultEnd

